import auth_requests from './requests/auth'
import edition_requests from './requests/editions'
import resource_requests from './requests/resources'
import coupon_requests from './requests/coupon'
import product_requests from './requests/product'
import user_requests from './requests/user'
import content_requests from './requests/content_creator'
import playlist_requests from './requests/playlist'
import author_requests from './requests/author'
import genre_requests from './requests/genre'
import interest_requests from './requests/interest'
import axios from 'axios'
import env from '../store/base/config/env'

const baseUrl = env.VUE_APP_API_PATH

if (!baseUrl) {
    throw new Error('API integration requires env variable: VUE_APP_API_PATH')
}

const api = axios.create({
    baseURL: baseUrl
})

api.user = user_requests
api.coupon = coupon_requests
api.product = product_requests
api.auth = auth_requests
api.editions = edition_requests
api.resources = resource_requests
api.content = content_requests
api.playlist = playlist_requests
api.author = author_requests
api.genre = genre_requests
api.interest = interest_requests
export default api
